import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import { initialExperimentBackendStatus } from '../../reducers/backendStatus/initialState';
var getBackendStatus = function getBackendStatus(experimentId) {
  return function (state) {
    var _state$experimentId;
    return (_state$experimentId = state[experimentId]) !== null && _state$experimentId !== void 0 ? _state$experimentId : initialExperimentBackendStatus;
  };
};
export default createMemoizedSelector(getBackendStatus);